import * as React from "react";
function SvgPin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M20.71 14.25a2 2 0 001.69.3l3.46-1.09L22 10.83l-6.19-4.2L11.94 4l.26 3.62a2 2 0 00.91 1.46l.71.48-4.49 6.61-2.73.73 9.23 6.27-.32-2.8 4.49-6.6zM11.67 19.38L6.14 28"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2.67}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
